import type { App } from 'vue'
import VueGoogleMaps from 'vue-google-maps-community-fork'
import countryLang from '@/lib/countryLang.json'

const GOOGLE_MAPS_KEY = 'AIzaSyDXYZHz-821B34i1rRgRKfySI20niR33_8'

let appRef: App | null = null
let registered = false

export function setGoogleMapsApp(app: App): void {
  appRef = app
}

export function registerGoogleMaps(countryCode?: string | null): void {
  if (!appRef || registered) return
  registered = true
  const language =
    (countryCode && countryLang[countryCode as keyof typeof countryLang]) ||
    'en'
  appRef.use(VueGoogleMaps, {
    load: {
      key: GOOGLE_MAPS_KEY,
      libraries: 'places',
      language,
      v: 'weekly',
    },
  })
}
